/* Relative "updated Ns ago" for the live pulse. Keeps the prototype's feel
   (seconds since last sync) but driven by a real timestamp. */
export function agoSeconds(iso: string | undefined, now: number = Date.now()): number {
  if (!iso) return 0;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return 0;
  return Math.max(0, Math.round((now - t) / 1000));
}

export function agoLabel(iso: string | undefined, now: number = Date.now()): string {
  const s = agoSeconds(iso, now);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  return `${h}h ago`;
}
